import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-archive",
  "use": "icon-archive-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-archive\" id=\"icon-archive\"><polyline points=\"21 8 21 21 3 21 3 8\" /><rect x=\"1\" y=\"3\" width=\"22\" height=\"5\" /><line x1=\"10\" y1=\"12\" x2=\"14\" y2=\"12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol